'use client'

import { useModel } from '../hooks/useModel'
import { useNodeMaterials } from '../hooks/useNodeMaterials'

export function InternetCafe(props) {
  const { nodes, materials } = useModel('/models/internetCafe.glb')
  const { getMat } = useNodeMaterials(materials)

  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes['1_sign_1_0'].geometry} material={getMat(nodes['1_sign_1_0'])} castShadow receiveShadow />
      <mesh geometry={nodes['1_1_back_0'].geometry} material={getMat(nodes['1_1_back_0'])} castShadow receiveShadow />
      <mesh geometry={nodes['1_1_0'].geometry} material={getMat(nodes['1_1_0'])} castShadow receiveShadow />
    </group>
  )
}

